import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthService} from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    const project_id = this.authService.getOrgID()

    // ✅ Skip login check for public routes
    const publicEndpoints = ['/verify', '/check-token', '/cors-test'];
    const shouldSkipAuth = publicEndpoints.some(endpoint => req.url.endsWith(endpoint) || req.url.includes(endpoint));

    if (!shouldSkipAuth && !this.authService.isLoggedIn()) {
      this.authService.logout();
      return throwError(() => new Error('Token expired'));
    }

    if(req.url.endsWith('/cors-test')) {
      return next.handle(req);
    }

      const cloned = req.clone({
        setHeaders: {
          Authorization: token ? `Bearer ${token}` : '',
          'X-Project-ID': project_id || ''
        }
      });
      return next.handle(cloned).pipe(
          catchError((error: HttpErrorResponse) => {
            if(error.status === 401 || error.status === 403){
              this.authService.logout();
            }
            return throwError(error);
          })
      );
  }
}
